import {
  BrowserModule,
  provideClientHydration,
} from '@angular/platform-browser';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
  withJsonpSupport,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, ViewportScroller } from '@angular/common';
import { CustomersModule } from './customers/customers.module';

import { ClipboardModule } from '@angular/cdk/clipboard';
import { AuthServiceService } from './shareModule/services/auth-service.service';
import { TokenInterceptor } from './shareModule/services/auth.interceptor';
import { NgbdSortableHeader } from './shareModule/directive/ngbd-sortable-header/ngbd-sortable-header.directive';
import { ShareModule } from './shareModule/shareModule';
import { RedirectionService } from './shareModule/services/redirection.service';
import { CommunityRedirectGuard } from './customers/util/guard/community-redirect-guard/community-redirect.guard';
import { PageLoaderComponent } from './shareModule/component/page-loader/page-loader/page-loader.component';

import { FeedbacksComponent } from './admin/auth/feedbacks/feedbacks.component';
import { NewHomepageComponent } from './admin/new-homepage/new-homepage.component';
import { DashboardAdminComponent } from './admin/layout/dashboard-admin/dashboard-admin.component';
import { SubAddNotesComponent } from './admin/sub-admin/sub-add-notes/sub-add-notes.component';
import { SubSubAdminComponent } from './admin/sub-admin/sub-sub-admin/sub-sub-admin.component';
import { NewHeaderComponent } from './admin/new-header/new-header.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { BookTimingModalComponent } from './customers/book-timing-modal/book-timing-modal.component';
import { ChatbotService } from './shareModule/component/chat/chatbot/chatbot.service';

import { SocketService } from './socket.service';
import { Router, Scroll } from '@angular/router';
import { filter } from 'rxjs';
import { ClientShareReviewLinkComponent } from './admin/client-share-review-link/client-share-review-link.component';
import { UserShareReviewLinkComponent } from './admin/user-share-review-link/user-share-review-link.component';
import { MyPageAnimateComponent } from './my-page-animate/my-page-animate.component';
import { MyNetworkComponent } from './my-network/my-network.component';
import { AmchartsGaugeComponent } from './amcharts-gauge/amcharts-gauge.component';
import { StoryKachiingComponent } from './nearby-map/story-kachiing/story-kachiing.component';
import { FaqChatKachiingComponent } from './nearby-map/faq-chat-kachiing/faq-chat-kachiing.component';

const mockWindow = {
  innerWidth: 1024, // Default width for SSR
};

@NgModule({
  declarations: [
    AppComponent,
    NgbdSortableHeader,
    PageLoaderComponent,
    FeedbacksComponent,
    NewHomepageComponent,
    DashboardAdminComponent,
    SubAddNotesComponent,
    SubSubAdminComponent,
    NewHeaderComponent,
    BookTimingModalComponent,
    ClientShareReviewLinkComponent,
    UserShareReviewLinkComponent,
    MyPageAnimateComponent,
    MyNetworkComponent,
    AmchartsGaugeComponent,
    StoryKachiingComponent,
    FaqChatKachiingComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    ClipboardModule,
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    //BsDatepickerModule.forRoot(),
    // CalendarModule.forRoot({
    //   provide: DateAdapter,
    //   useFactory: adapterFactory,
    // }),
    // ChartsModule,
    //Ng2SearchPipeModule,
    // NgxShimmerLoadingModule,
    // NzIconModule,
    // TooltipModule.forRoot(),
    // AngularFireModule.initializeApp(firebaseEnv.firebaseConfig),
    //AngularFireMessagingModule,
    //AngularFireModule.initializeApp(firebaseEnv.firebase),
    //MessagingModule,

    //AngularFireAuthModule,
    // AngularFirestoreModule,
    ShareModule,
    CommonModule,
    // CustomersModule,
    StoreModule.forRoot({}), // Initialize the store with an empty object
    EffectsModule.forRoot([]), // Initialize root effects
    CustomersModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  providers: [
    SocketService,
    RedirectionService,
    HttpClient,
    CommunityRedirectGuard,
    AuthServiceService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
    ChatbotService,
    provideClientHydration(),
    {
      provide: 'WINDOW',
      useFactory: () => (typeof window !== 'undefined' ? window : mockWindow),
    },
  ],
})
export class AppModule {
  constructor(router: Router) {
    router.events
      .pipe(filter((e: any): e is Scroll => e instanceof Scroll))
      .subscribe((e) => {
        // No scrolling actions
      });
  }
}
